import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {EventsService} from '../../events.service';
import {GlobalService} from '../../../global.service';
import {Router, ActivatedRoute, NavigationEnd, RouterOutlet, ActivationStart} from '@angular/router';
import {isPlatformBrowser} from "@angular/common";

import {
  PerfectScrollbarConfigInterface,
  PerfectScrollbarComponent,
  PerfectScrollbarDirective
} from 'ngx-perfect-scrollbar';
import {BehaviorSubject} from 'rxjs';
import {EventDialogComponent} from '../../../Dialogs/event-dialog/event-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-shawarmer',
  templateUrl: './shawarmer.component.html',
  styleUrls: ['./shawarmer.component.css']
})
export class ShawarmerComponent implements OnInit {
  language: any;
  langChosen: string = 'ar';
  AppSettings: any;
  mobileView: boolean = false;
  dialogRef;
  public config: PerfectScrollbarConfigInterface = {
    // suppressScrollX:true
  };
  @ViewChild(PerfectScrollbarComponent) componentRef?: PerfectScrollbarComponent;
  @ViewChild(PerfectScrollbarDirective) directiveRef?: PerfectScrollbarDirective;

  games: Array<any> ;
  city = {city:"Jubail"}
  constructor(public dialog: MatDialog, private globalService:GlobalService,private router: Router, private activeRoute: ActivatedRoute,
              public eventService: EventsService , private titleService:Title) {
    this.titleService.setTitle('Shawarmer')
    if (this.globalService.isBrwoser) {
      if (window.screen.width < 768) {
        this.mobileView = true;
      }
    }
  }

  ngOnInit() {
   this.eventService.eventGames.subscribe(
      games =>{
        this.games = games
      })
    this.eventService.insomniaGame = this.router.url.split('/')[2];
    // initsnow();

    this.router.events.subscribe(event => {


      if (event instanceof NavigationEnd) {
        this.eventService.insomniaGame = event.url.split('/')[2];
      }
    });
    if (this.router.url.split('/').length < 3) {
      this.router.navigateByUrl('/shawarmer/fifa');

    }

    // set default language
    if (this.globalService.isBrwoser) {
      if (localStorage.getItem('language')) {
        this.language = require('./lang/' + localStorage.getItem('language') + '.json');
        this.langChosen = localStorage.getItem('language');
      } else {
        this.language = require('./lang/ar.json');
      }
    }
  }

  languageChange(value) {
    if (this.globalService.isBrwoser) {
      this.langChosen = value;
      this.language = require('./lang/' + value + '.json');
      this.globalService.language = value;
      localStorage.setItem('language', value);
    }
  }

  isActive(instruction: any[]): boolean {
    // Set the second parameter to true if you want to require an exact match.
    return this.router.isActive(this.router.createUrlTree(instruction), false);
  }


  isLinkActive(game) {
    if(this.router.url.includes(game)){
      return true;
    }else{
      return false;
    }
  }

  multidialog(dialogType) {
    if (this.dialogRef)
      this.dialogRef.close('')
    this.dialogRef = this.dialog.open(EventDialogComponent, {
      data: {
        type: dialogType
      },
      width: '500px',
      height:'500px'
    });
  }
  // rules(){
  //   let dialogRef = this.dialog.open(EventDialogComponent, {
  //     data: {
  //       type: 'Rules'
  //     },
  //     width: '500px',
  //     height:'500px'
  //   });
  // }
  // contact(){
  //   let dialogRef = this.dialog.open(EventDialogComponent, {
  //     data: {
  //       type: 'Contact'
  //     },
  //     width: '500px',
  //     height:'500px'
  //   });
  // }
}
